import Vue from 'vue'
import Vuex from 'vuex'

// import mutations from './mutations'
// import actions from './actions'
// import getters from './getters'
// import msite from './modules/msite'
import supply from './modules/supply'
import user from './modules/user'
import exhibition from './modules/exhibition'

Vue.use(Vuex)

export default new Vuex.Store({
  // mutations,
  // actions,
  // getters,
  modules:{
  //   msite,
  exhibition,
  user,
  supply
  }
})
